// extracted by mini-css-extract-plugin
module.exports = {"fadeDownSection":"FadeDown-module--fade-down-section--3eqjt","isVisible":"FadeDown-module--is-visible--1NZ2e"};